import { colors } from 'bold-ui'
import React from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { LembreteFormModel } from 'view/atendimentos/detail/components/modals/lembretes/components/LembreteForm'

import { AsideSection } from '../AsideSection'
import { LembretesCard } from './LembretesCard'

interface LembretesSectionProps {
  prontuarioId: ID
  lembretesCache: LembreteFormModel[]
}

export function LembretesSection(props: LembretesSectionProps) {
  const history = useHistory()
  const match = useRouteMatch()

  const handleClick = () => history.push(`${match.url}/lembretes`)

  return (
    <AsideSection
      title='Lembretes'
      tooltip='Ver/Adicionar lembretes'
      onClick={handleClick}
      titleBackgroundColor={colors.yellow.c90}
      style={{ maxHeight: '17.5rem', overflow: 'hidden' }}
    >
      <LembretesCard {...props} />
    </AsideSection>
  )
}
